//EXTERNAL
import React from "react"
//COMPONENTS
//ASSETS
//FUNCTIONS

const disabledButton = {
  cursor: "not-allowed",
  // opacity: "0.65",
  color: "gray",
  width: "8rem",
  padding: "10px 0"
}

const ActionButton = ({ isDisabled, clickHandler, text }) => {
  return (
    <button disabled={isDisabled} onClick={clickHandler} style={isDisabled ? disabledButton : { width: "8rem", padding: "10px 0" }} className="f7 mv2 mr2 sans-serif pointer black bg-white ba b--moon-gray dim br1">
      {text}
    </button>
  )
}

export default ActionButton
